import { Button, notification, Row } from 'antd';
import React, { Suspense, useState } from 'react';

import { apiCms } from 'shared/api';
import { getWsinForAutoComplete } from 'shared/api/catalog';
import { Loading } from 'shared/components/Loading';
import errorHandler from 'shared/utils/errorHandler';

const LazyDynamicInputs: any = React.lazy(() => import('shared/components/DynamicInputs/DynamicInputs'));

interface IAdminActionProps {
	productId: string;
	wsinMapping: any;
	companyId: string;
	isAdminView: boolean;
	setReloadCatalogue: (f: Function) => void;
	reloadList: () => void;
}

export default function AdminWSINActions(props: Readonly<IAdminActionProps>) {
	const [showInputs, setShowInputs] = useState(false);

	const handleWsinMap = async (inputs: any) => {
		try {
			const wsinMap: any = {};
			inputs.forEach((item: any) => (wsinMap[item?.wsin] = Number(item.quantity)));

			const {
				data: { status, message }
			} = await apiCms.post('/catalogue/map-wsin', {
				companyId: props.companyId,
				catalogueId: props.productId,
				data: wsinMap
			});
			if (!status) errorHandler(new Error(message));
			notification.success({
				message: 'WSIN Mapped Successfully',
				description: 'Mapped successfully.',
				placement: 'topRight'
			});
			props.setReloadCatalogue((prev: number) => prev + 1);
			props.reloadList();
		} catch (error) {
			errorHandler(error);
		}
	};

	const deleteWsinMap = async () => {
		try {
			const { data: deleteResp } = await apiCms.delete('/catalogue/remove-wsin-map', {
				data: { catalogueId: props.productId, companyId: props.companyId }
			});

			if (!deleteResp.status) {
				throw new Error(deleteResp.message);
			}

			notification.success({
				message: 'WSIN Mapping Deleted',
				description: 'WSIN mapping deleted successfully.',
				placement: 'topRight'
			});

			props.setReloadCatalogue((prev: number) => prev + 1);
			props.reloadList();
		} catch (error) {
			errorHandler(error);
		}
	};

	if (!props.isAdminView) return <></>;

	return props.wsinMapping ? (
		<Row className="row1-row">
			<Button type="primary" onClick={deleteWsinMap}>
				Delete WSIN Mapping
			</Button>
		</Row>
	) : (
		<Row className="row1-row">
			<Button type="primary" onClick={() => setShowInputs((prev) => !prev)}>
				Map WSIN
			</Button>
			{showInputs ? (
				<Suspense fallback={<Loading />}>
					<LazyDynamicInputs
						inputFields={[
							{
								inputKey: 'wsin',
								defaultValue: '',
								inputType: 'text',
								autoComlete: true,
								getOptions: getWsinForAutoComplete,
								placeholder: 'WSIN'
							},
							{
								inputKey: 'quantity',
								defaultValue: 1,
								inputType: 'number',
								autoComlete: false,
								placeholder: 'QUANTITY',
								min: 1
							}
						]}
						companyId={props.companyId}
						handleSubmit={handleWsinMap}
					/>
				</Suspense>
			) : null}
		</Row>
	);
}
